"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var Attachment_1 = require("../api/Attachment");
var UrlParam_1 = require("../helpers/UrlParam");
var AttachmentConnector = /** @class */ (function () {
    function AttachmentConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Get documents from a party
     * @param partyId
     * @param apiParams
     */
    AttachmentConnector.prototype.getPartyDocuments = function (partyId, apiParams) {
        var params = new URLSearchParams();
        if (apiParams) {
            UrlParam_1.appendDefaultParams(params, apiParams);
        }
        return fetchRequest_1.fetchRequestWithPagination(Attachment_1.getPartyDocumentsUsingGET(partyId, params), this.baseUrl);
    };
    /**
     * Get documents from a policy
     * @param sipasUuid
     * @param apiParams
     */
    AttachmentConnector.prototype.getPolicyDocuments = function (sipasUuid, apiParams) {
        var params = new URLSearchParams();
        if (apiParams) {
            UrlParam_1.appendDefaultParams(params, apiParams);
        }
        return fetchRequest_1.fetchRequestWithPagination(Attachment_1.getPolicyDocumentsUsingGET(sipasUuid, params), this.baseUrl);
    };
    /**
     * Get file from a document
     * @param attachmentId
     * @param attachmentSeqNo
     * @param apiParams
     */
    AttachmentConnector.prototype.getAttachments = function (attachmentId, attachmentSeqNo, apiParams) {
        var params = new URLSearchParams();
        if (apiParams) {
            UrlParam_1.appendDefaultParams(params, apiParams);
        }
        return fetchRequest_1.fetchBinary(Attachment_1.getAttachmentsUsingGET(attachmentId, attachmentSeqNo, params), this.baseUrl);
    };
    return AttachmentConnector;
}());
exports.default = AttachmentConnector;
